// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/Responsive.css
// module id = 1150
// module chunks = 0